export default {
      id: "kiosque_feuilleter-usage",
      viewBox: "0 0 43 43",
      url: "../dist/images/" + "sprite.svg#kiosque_feuilleter-usage",
      toString: function () {
        return this.url;
      }
    }